import OBusinessHourSettingList from './index.vue';

OBusinessHourSettingList.install = app => {
  app.component(OBusinessHourSettingList.name, OBusinessHourSettingList);
};

export default OBusinessHourSettingList;
